import { Box } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const PendingItemsContainer = styled(Box)`
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  display: grid;
`
